import { keyValueStorage } from '../../Core/utils/keyValueStorage';
import { getMsalApp } from './ssoUtils';

export const refreshToken = ssoObject => {
  const { getData } = keyValueStorage();
  const userAccount = JSON.parse(getData('userAccount'));
  if (userAccount) {
    for (const key of Object.keys(window.sessionStorage)) {
      if (key.includes('"authority":')) {
        window.sessionStorage.removeItem(key);
      }
    }
    const tokenRequest = {
      scopes: [ssoObject.clientId],
      loginHint: ssoObject.userEmail
    };
    const msalApp = new getMsalApp(
      ssoObject.clientId,
      ssoObject.tenantId,
      ssoObject.redirectUri
    );

    msalApp.setAccountCache(userAccount);
    msalApp.account = userAccount;

    return msalApp
      .acquireTokenSilent(tokenRequest)
      .then(response => {
        return response;
      })
      .catch(err => {
        return { isError: true, data: err };
      });
  }
};
